import { Switch as MaterialSwitch } from '@mui/material';
import { styled } from '@mui/material/styles';

import { PRIMARY_SILVER_COLOR } from '../../../themes/light';

const Switch = styled(MaterialSwitch)({
  width: '32px',
  height: 16,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      '& + .MuiSwitch-track': {
        backgroundColor: '#15e88f',
        opacity: 1,
        border: 'none',
      },
      '& .MuiSwitch-thumb': {
        color: 'white',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    border: `1px solid ${PRIMARY_SILVER_COLOR[400]}`,
    backgroundColor: `${PRIMARY_SILVER_COLOR[400]}`,
    opacity: 1,
  },
});

export default Switch;
